<template>
  <div class="summary-table-container">
    <div class="summary-table-title">
      {{ $t('CLOSING_REASONS.TABLE.CLOSING_REASON_TOTAL') }}
    </div>
    <div class="summary-table-wrapper">
      <table>
        <caption class="visually-hidden">
          {{
            $t('CLOSING_REASONS.TABLE.CLOSING_REASON_TOTAL')
          }}
        </caption>
        <thead>
          <tr>
            <th scope="col">{{ $t('CLOSING_REASONS.TABLE.RESOLVED_BY') }}</th>
            <th v-for="reason in reasonList" :key="reason" scope="col">
              {{ reason }}
            </th>
            <th scope="col">{{ $t('CLOSING_REASONS.TABLE.TOTAL') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, agent, index) in summaryData"
            :key="agent"
            :class="{ 'row-alt': index % 2 === 1 }"
          >
            <td class="agent-cell" :title="agent">
              {{ truncateText(agent, 25) }}
            </td>
            <td v-for="reason in reasonList" :key="reason">
              {{ row[reason] || 0 }}
            </td>
            <td>{{ getTotalForAgent(row) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th scope="row" class="agent-cell">
              {{ $t('CLOSING_REASONS.TABLE.TOTAL') }}
            </th>
            <th
              v-for="reason in reasonList"
              :key="reason"
              class="bold-total"
              scope="col"
            >
              {{ getTotalForReason(reason) }}
            </th>
            <th class="bold-total" scope="row">{{ getOverallTotal }}</th>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClosingReasonsSummaryTable',
  props: {
    reasonsData: {
      type: Array,
      required: true,
    },
  },
  computed: {
    summaryData() {
      const summary = {};
      this.reasonsData.forEach(item => {
        const agent =
          item.resolved_by?.name || this.$t('CLOSING_REASONS.TABLE.UNKNOWN');
        const reason =
          item.closing_reason?.name?.name ||
          this.$t('CLOSING_REASONS.TABLE.NO_REASON');

        if (!summary[agent]) summary[agent] = {};
        if (!summary[agent][reason]) summary[agent][reason] = 0;
        summary[agent][reason]++;
      });
      return summary;
    },
    reasonList() {
      const set = new Set();
      this.reasonsData.forEach(item => {
        const reason =
          item.closing_reason?.name?.name ||
          this.$t('CLOSING_REASONS.TABLE.NO_REASON');
        set.add(reason);
      });
      return Array.from(set);
    },
    getOverallTotal() {
      return this.reasonsData.length;
    },
  },
  methods: {
    getTotalForAgent(row) {
      return Object.values(row).reduce((sum, count) => sum + count, 0);
    },
    getTotalForReason(reason) {
      return Object.values(this.summaryData).reduce((sum, agentRow) => {
        return sum + (agentRow[reason] || 0);
      }, 0);
    },
    truncateText(text, maxLength) {
      return text.length > maxLength
        ? text.slice(0, maxLength - 3) + '...'
        : text;
    },
  },
};
</script>

<style scoped>
.summary-table-container {
  width: 100%;
  margin: 0;
  padding: 0;
}

.summary-table-title {
  font-weight: bold;
  font-size: 15px;
  background-color: #e5e5e5;
  padding: 10px;
  text-align: right;
  border-bottom: 1px solid #ccc;
}

.summary-table-wrapper {
  overflow-x: auto;
  width: 100%;
  margin: 0;
  padding: 0;
}

table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin: 0;
  padding: 0;
  border-spacing: 0;
}

th,
td {
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
}

.row-alt {
  background-color: #f9f9f9;
}

tfoot {
  font-weight: bold;
  background: #f0f0f0;
  margin: 0;
  padding: 0;
}

.bold-total {
  font-weight: bold;
}

.agent-cell {
  max-width: 180px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

tfoot th,
tfoot td {
  padding: 8px 10px;
  line-height: 1.2;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
